import { IContentBlockValuePropProps } from "@proj-common/types"
import heroImg from "@proj-client/assets/imgs/landing/hero.png"
import heroVideo from "@proj-client/assets/vids/hero.mp4"
import { getDefaultPlanLookupKey } from "../generic/plans"
import { createRef, useEffect, useRef, useState } from "react"

interface IDynamicTaglineProps {
    words?: string[]
    prefix?: string
    textClassName?: string
    wordCropHeight?: string
    highlightBgColor?: string
}
const DynamicTagline = ({ words, prefix, textClassName, wordCropHeight, highlightBgColor }: IDynamicTaglineProps) => {

    //const words = props.words || ['COFFEE', 'TEA', 'HOT CHOCOLATE']

    const [index, setIndex] = useState(0)
    const [transition, setTransition] = useState(false)

    const transitionContainer = createRef<HTMLDivElement>()

    useEffect(() => {
        const timer = setInterval(() => {
            setTransition(true)
            setTimeout(() => {
                setIndex((prevIndex) => (prevIndex + 1) % words.length)
                setTransition(false)
            }, 1000) // Transition time
        }, 3000) // Change word every 3 seconds
        return () => clearInterval(timer)
    }, [])

    useEffect(() => {
        if (words?.length) {
            let maxWidth = 0
            words.forEach(word => {
                const width = word.length
                if (width > maxWidth) {
                    maxWidth = width
                }
            })
            const container = transitionContainer.current
            if (container) {
                container.style.width = `${maxWidth}ch`
            }
        }
    }, [words])

    const currentWord = words[index]
    const nextWord = words[(index + 1) % words.length]

    return (
        <div className={`flex flex-row items-center ${textClassName}`}>
            {prefix && <div>{prefix}&nbsp;</div>}
            <div ref={transitionContainer} className={`relative md:-ml-1 pl-1 md:pl-2 ${highlightBgColor ? highlightBgColor : "bg-yellow-300"} rounded-md overflow-hidden ${wordCropHeight ? wordCropHeight : " h-full"}`}>
                <div className={`absolute bottom-0 ${transition ? 'animate-nextWordIn' : ''}`}>
                    {currentWord}
                </div>
                {transition && (
                    <div className={`absolute bottom-0 animate-currentWordOut`}>
                        {nextWord}
                    </div>
                )}
            </div>
        </div>
    )
}

export const ContentBlockHero = (props: IContentBlockValuePropProps) => {

    const [isPlaying, setIsPlaying] = useState(false)
    const videoRef = useRef(null)

    const handleVideoClick = () => {
        setIsPlaying(!isPlaying)
        if (videoRef.current) {
            const video = videoRef.current
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
        }
    }

    return (
        <div className={`bg-transparent ${props.bgColor}  pl-4 pr-4 pt-8 pb-8`}>
            <div className="container flex flex-col mx-auto place-items-center">
                <div className="flex flex-col max-w-4xl md:max-w-7xl justify-items-center md:mt-20">

                    <div className="flex flex-row self-center flex-1">
                        <div className="flex flex-col items-center text-center">
                            {
                                // Team workshops made&#xa0;simple.
                                //Lightning fast workshops.<br />
                                // Immediate results.
                            }
                            <DynamicTagline
                                prefix="Your next"
                                words={['PowerPoint', 'Roadmap', 'Process', 'Strategy', 'Moonshot', 'Reorg']}
                                textClassName="text-2xl font-bold md:text-6xl font-display  leading-snug md:leading-snug text-slate-900"
                            />
                            <h1 className={"text-2xl font-bold md:text-6xl font-display  leading-snug md:leading-snug text-slate-900"}>
                                Brainstormed by your team.
                            </h1>

                            <p className={"mt-5 md:mt-10 place-self-center font-display font-medium text-sm  md:text-2xl leading-relaxed text-slate-900"}>
                                IdeateLive is an automated team workshop platform with PowerPoint export.
                            </p>

                            <div className="flex flex-row space-x-4 mt-5 md:mt-10 mb-10 md:mb-20 place-self-center ">
                                <a
                                    //href="/register"
                                    onClick={props.ctaHandler}
                                    className="umami--click--get-started idtn-btn-primary-lg font-display "
                                    aria-label={props.ctaText}
                                >
                                    {props.ctaText}
                                </a>
                                {/* <a
                                    href="https://calendly.com/szakacsszilard"
                                    className="umami--click--request--demo idtn-btn-primary-lg font-display"
                                >
                                    Book a demo
                                </a> */}
                            </div>
                        </div>
                    </div>

                    <div className="flex-1 overflow-hidden rounded-md md:rounded-lg -mb-[17vh] max-h-[600px] md:max-h-screen aspect-video  md:-mb-0 md:ml-10 md:mr-10 flex flex-row justify-center relative cursor-pointer"
                        onClick={handleVideoClick} >
                        <video
                            ref={videoRef}
                            className="object-cover absolute inset-0 p-4 md:p-0"
                            playsInline={true}
                            loop={true}
                            muted={true}
                        >
                            
                            <source src={heroVideo} type="video/mp4" />
                            
                        </video>
                        {!isPlaying && <img src={heroImg} alt="Start demo video" className="object-cover absolute inset-0" />}
                        {!isPlaying && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                                <i className="fa-solid fa-circle-play text-white md:text-8xl text-6xl " ></i>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}